<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ title }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('agenda.buyers')}}</label>
              <el-form-item prop="buyers">
                <base-el-select ref="buyersSelect" class="w-full" :options="buyers" v-model="form.buyers" multiple filterable :diasbled="isLoadingSelect" :loading="isLoadingSelect" @visible-change="onExpand" @change="onChangeInput" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div>
        <base-button mode="secondary-phantom-blue"
          class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')"
          @click="$refs.buyersSelect.selectAll()"
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
          class="w-full"
          @click="$refs.buyersSelect.unselectAll()"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
      </div>
      <div  class="flex-none flex items-center justify-between space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import { getContactos } from '@/services/configurations/grouping/getContactos'

export default
{
  name: 'template-link-buyers-dialog',
  props: {
    title: {
      type: String,
      default: 'Título'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    clientId: {
      type: [Number, String],
      default: -1
    },
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        buyers: []
      },
      buyers: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (!value) this.form.buyers = []
    },
  },
  mounted: async function () {
    this.isLoadedData = false
    const params = {
      rolAgenda: 2,
      idCliente: null,
    }
    if (this.clientId !== -1 && this.clientId !== '-1') {
      params.idCliente = this.clientId
    }
    const data = await getContactos(params)
    if (data.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
    } else {
      data.respuesta.forEach(row => {
        const label = row.NameCorporateName + ' ' + (row.FirstSurname || '')
        this.buyers.push({ value: row.IdSociedad, label: label })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    isEmptyList: function () {
      return this.buyers === undefined || this.buyers === null || this.buyers.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.buyers.length === this.form.buyers.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.buyers)
    },
  }
}
</script>
